class FeaturedVideoCard extends HTMLElement {
  #video;
  #boundEnter;
  #boundLeave;
  #boundFocusIn;
  #boundFocusOut;
  #isTouch = false;

  connectedCallback() {
    this.#video = this.querySelector('video');
    if (!this.#video) return;

    this.#video.muted = false;
    this.#video.removeAttribute('muted');
    this.#video.defaultMuted = false;
    this.#video.volume = 1;
    this.#video.playsInline = true;
    this.#video.setAttribute('playsinline', '');
    this.#video.setAttribute('webkit-playsinline', '');

    this.#isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;
    this.#boundEnter = this.#play.bind(this);
    this.#boundLeave = this.#pause.bind(this);
    this.#boundFocusIn = this.#play.bind(this);
    this.#boundFocusOut = this.#pause.bind(this);

    if (this.#isTouch) {
      this.classList.add('is-touch');
      this.#setupTouch();
      return;
    }

    this.addEventListener('mouseenter', this.#boundEnter);
    this.addEventListener('mouseleave', this.#boundLeave);
    this.addEventListener('focusin', this.#boundFocusIn);
    this.addEventListener('focusout', this.#boundFocusOut);
  }

  disconnectedCallback() {
    this.removeEventListener('mouseenter', this.#boundEnter);
    this.removeEventListener('mouseleave', this.#boundLeave);
    this.removeEventListener('focusin', this.#boundFocusIn);
    this.removeEventListener('focusout', this.#boundFocusOut);
  }

  #setupTouch() {
    this.addEventListener('click', (event) => {
      if (event.target.closest('a')) return;
      if (this.#video.paused) {
        this.#play();
      } else {
        this.#pause();
      }
    });
  }

  #pauseOthers() {
    document.querySelectorAll('featured-video-card.is-playing').forEach((card) => {
      if (card !== this && typeof card.pauseVideo === 'function') {
        card.pauseVideo();
      }
    });
  }

  #play() {
    if (!this.#video) return;

    this.#pauseOthers();
    this.classList.add('is-playing');
    this.#video.muted = false;
    this.#video.removeAttribute('muted');
    this.#video.volume = 1;

    const playPromise = this.#video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {
        // Some browsers block sound until a click; retry muted then unmute if possible
        this.#video.muted = true;
        this.#video.play()
          .then(() => {
            this.#video.muted = false;
          })
          .catch(() => {});
      });
    }
  }

  #pause() {
    this.pauseVideo();
  }

  pauseVideo() {
    if (!this.#video) return;
    this.classList.remove('is-playing');
    this.#video.pause();
    try {
      this.#video.currentTime = 0;
    } catch (error) {
      // Ignore seek errors on some browsers
    }
  }
}

if (!customElements.get('featured-video-card')) {
  customElements.define('featured-video-card', FeaturedVideoCard);
}
